import type { IconProps } from './types';

export function Conjunto({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M32 60 Q42 56 52 60 Q68 70 84 60 Q94 56 104 60 Q116 70 124 80 Q120 86 116 88 Q110 84 104 76 L104 136 Q104 144 96 144 L36 144 Q28 144 28 136 L28 76 Q22 84 16 88 Q12 86 8 80 Q20 70 32 60 Z" />
      <path d="M140 112 Q190 108 240 112 Q240 122 240 132 Q238 178 236 224 Q224 228 212 224 Q204 190 196 156 Q188 190 180 224 Q168 228 156 224 Q150 178 144 132 Q140 122 140 112 Z" />
      <path d="M140 132 Q190 136 240 132" />
    </svg>
  );
}
